const suggestTypes = {
    SET_DATA_FORM: 'SET_DATA_FORM',
	CLEAR_DATA_FORM: 'CLEAR_DATA_FORM'
};

export default suggestTypes;
